import React from 'react'
import { MemberStrikethroughPrice } from '@moonpig/web-core-types-graphql'
import { Box, Text } from '@moonpig/launchpad-components'
import { LogoPlusPillInverted } from '@moonpig/launchpad-assets'

export const MemberStrikethroughPriceDisplay = ({
  member,
  original,
}: MemberStrikethroughPrice) => {
  return (
    <Box display={'flex'} gap={8} alignItems={'center'}>
      <Text typography="typeBodyLabel" color="colorFeedbackSuccess">
        {member.display}
      </Text>
      <s>
        <Text typography="typeBodyText">{original.display}</Text>
      </s>
      <LogoPlusPillInverted width={50} />
    </Box>
  )
}
